import { useEffect, useState } from 'react';
import apiService from '../../axios/apiService';
import { useLocation } from 'react-router-dom';
import { getSearchParamFromLocation } from '../../utils/mapper';
import { ApplicationRoutes } from '../../authguard/routes';

export const useGetClinic = () => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const getClinic = async () => {
    // Fetch clinic
    setLoading(true);
    try {
      const id = getSearchParamFromLocation('id', location);
      const response = await apiService.getClinic(id);
      response && setData(response); // update data state
      return response;
    } catch (error) {
      console.log('Fetch Clinic Error: ', error);
    } finally {
      setLoading(false);
    }
  };

  // Initial component mount
  useEffect(() => {
    if (location?.pathname === ApplicationRoutes.ClinicEdit) {
      getClinic();
    }
  }, [location?.search]);

  return {
    data,
    loading,
    getClinic,
  };
};
